// navbar
$('.shop-dd-btn').on('click', function () {
  // $('.shop-dd').toggleClass('shop-dd-active');
  if ($('.shop-dd').hasClass('shop-dd-active')) {
    closeShopDD();
    closeMNavDD();
  } else {
    openShopDD();
    closeMNavDD();
  }
});
function openShopDD() {
  $('.shop-dd').addClass('shop-dd-active');
  $('.shop-dd-btn').text('Close');
}
function closeShopDD() {
  $('.shop-dd').removeClass('shop-dd-active');
  $('.shop-dd-btn').text('Shop');
}

$('.search-dd-btn').on('click', function () {
  if ($('.search-dd').hasClass('search-dd-active')) {
    closeSearchDD();
    closeMNavDD();
  } else {
    openSearchDD();
    closeMNavDD();
  }
});
function openSearchDD() {
  $('.search-dd').addClass('search-dd-active');
}
function closeSearchDD() {
  $('.search-dd').removeClass('search-dd-active');
}

$('.navdd-btn-main').on('click', function () {
  if ($('.fullnav').hasClass('fullnav-mobile-active')) {
    closeMNavDD();
    closeShopDD();
  } else {
    openMNavDD();
    closeShopDD();
  }
});
function openMNavDD() {
  $('.fullnav').addClass('fullnav-mobile-active');
}
function closeMNavDD() {
  $('.fullnav').removeClass('fullnav-mobile-active');
}

// color selector functionality
$('.color-selector-wrap').each(function () {
  var thisProduct = $(this);
  var csImg = $(this).find('.color-selector-img');
  var csSwatches = $(this).find('.color-selector');
  $(csSwatches).on('mouseenter', function () {
    var color = $(this).attr('data-color');
    var newSrc = $(thisProduct)
      .find('.color-selector-src[data-color*="' + color + '"]')
      .data('src');
    $(csImg).attr('src', newSrc);
  });
});

$(document).ready(function () {
  // replace ampersands for 192 font
  $('h1, h2, h3, h4, h5, h6, .fixfont').each(function () {
    // Replace unwrapped `&` only
    const content = $(this).text();
    let updatedContent = content.replace(/&amp;|&(?![^<]*<\/span>)|['?.,!-.:/]/g, function (match) {
      return '<span class="custom-ampersand">' + match + '</span>';
    });

    // replace ® as well
    updatedContent = updatedContent.replace(/\®/g, '<sup class="custom-ampersand trademark-txt">®</sup>');

    // // replace : as well
    // updatedContent = updatedContent.replace(/\:/g, '<span class="custom-ampersand">:</span>');
    // // replace / as well
    // updatedContent = updatedContent.replace(/\//g, '<span class="custom-ampersand">/</span>');
    $(this).html(updatedContent);
  });

  $('.wave-test.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $('.owl-carousel.owl-flavors').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
        merge: true,
        margin: 10,
        mergFit: true,
        stagePadding: 50,
        nav: false,
      },
      600: {
        items: 3,
        margin: 10,
      },
      1200: {
        items: 4,
        margin: 10,
      },
      1400: {
        items: 6,
        margin: 10,
      },
    },
  });

  $('.owl-three.owl-carousel').owlCarousel({
    items: 1,
    loop: false,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
  $('.owl-four.owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $('.owl-six.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  });

  // Instagram gallery carousel is now initialized dynamically via instagram-feed.js
  // $('.liss-gallery.owl-carousel').owlCarousel({ ... });

  // Lazy Load Header Video
  $('.bg-vid-elems').each(function () {
    let vidSection = $(this);
    let vidTarget = $(this).find('.bg-vid-target');
    let vidSrc = vidTarget.attr('data-src');

    $(vidTarget).html('<video autoplay muted loop playsinline><source src="' + vidSrc + '" type="video/mp4"></video>');

    $(vidTarget).find('video')[0].load();

    $(vidTarget)
      .find('video')[0]
      .addEventListener(
        'loadeddata',
        function () {
          $(vidSection).find('.bg-img-container').css('opacity', '0');

          $(vidTarget)
            .find('video')[0]
            .play()
            .catch((error) => {
              console.log(error);
            });
        },
        false
      );
  });

  // Play button used on the recipe videos
  var videoContainers = $('.video-container');
  $(videoContainers).each(function () {
    var video = $(this).find('.videoplayable')[0];
    var playButton = $(this).find('.play-button');
    var videoControls = $(this).find('.video-controls');

    // Initially hide video controls
    videoControls.hide();

    function togglePlayPause() {
      if (video.paused) {
        video.play();
        playButton.hide();
        videoControls.show();
      } else {
        video.pause();
        playButton.show();
        videoControls.hide();
      }
    }

    function formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    }

    playButton.on('click', togglePlayPause);
    $(video).on('click', togglePlayPause);

    videoControls.find('.volumeControl').on('input', function () {
      video.volume = $(this).val();
    });

    videoControls.find('.fullscreenButton').on('click', function () {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        // Firefox
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        // IE/Edge
        video.msRequestFullscreen();
      }
    });

    videoControls.find('.seekControl').on('input', function () {
      var seekTo = video.duration * ($(this).val() / 100);
      video.currentTime = seekTo;
    });

    video.addEventListener('timeupdate', function () {
      var value = (100 / video.duration) * video.currentTime;
      videoControls.find('.seekControl').val(value);
      videoControls.find('.current-time').text(formatTime(video.currentTime));
    });

    video.addEventListener('loadedmetadata', function () {
      videoControls.find('.total-time').text(formatTime(video.duration));
    });
  });
});

// scroll back to the top when pagination is clicked
$(document).on('click', 'a.page', function () {
  $('html, body').animate(
    {
      scrollTop: $('.list').offset().top - 170,
    },
    500
  );
});
